import Flow from "@/lib/Flow";
import steps from "./steps";
import StepCounter, { useStepCounter } from "./components/StepCounter";

type Props = {
  requestManager: RequestManager;
  wizard: Controls;
};

export type WizardProps<T = Keyable> = FlowProviding<T> & {
  requestManager: RequestManager;
  wizard: Controls;
};

export default function Wizard({ requestManager, wizard }: Props) {
  const { stepId, handleStepChange, stepsList } = useStepCounter();

  return (
    <>
      <StepCounter id={stepId} steps={stepsList} />
      <Flow
        steps={steps}
        initialStep="add-camera"
        requestManager={requestManager}
        wizard={wizard}
        onStep={handleStepChange}
      />
    </>
  );
}
